import React, { useLayoutEffect, useRef, useState } from 'react';
import { useEffect } from 'react';
import { Card, Carousel, Col, Modal, Row, Spinner } from 'react-bootstrap';
import BannerRequestService from 'services/banner-request';
import "./style.scss";
import { Settings, AddCircle } from '@material-ui/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTimes } from '@fortawesome/free-solid-svg-icons'
import Can from 'components/Can';
import { useProfile } from 'models';


function SettingsCardBanner({
  onClose, list, update
}){
  const widthItem = 205;
  const [ loadMoreImage, setLoadMoreImage ] = useState(false);
  const [ editIndex, setEditIndex ] = useState(-1);

  const ref = useRef();
  const refBody = useRef();

  useLayoutEffect(() => {
    if(ref && ref.current && refBody && refBody.current){
      let area = ref.current;
      let body = refBody.current;
      let bcra = area.getBoundingClientRect();
      let bcrb = body.getBoundingClientRect();
      let l = Array.from(area.getElementsByClassName("modal-item-config")).filter(element => !element.classList.contains("item-config-more-btn"));
      let posInit = null;
      let currentMove = null;
      let posXpx = null;
      let changed = -1;
      let currentIndex = -1;
      let interval_id = null;

      async function renderPos(element){
        currentMove = null;
        if(element){
          element.style.transition = null;
          element.style.zIndex = null;
          
          if(changed !== -1){
            let a = changed;
            changed = -1;
            element.style.left = `${a*widthItem}px`;
            let res = await BannerRequestService.change_position(currentIndex,a);

            // console.log({res});
            l.forEach((ele, i)=>{
              ele.style.transition = "none";
              ele.style.zIndex = null;
              ele.style.left = `${i*widthItem}px`;
              setTimeout(()=>{
                ele.style.transition = null;
              },[400]);
            });
            // console.log([...l]);
            // // element.style.left = `${changed*widthItem}px`;
            if(update)update(res.data);
          } else {
            element.classList.remove("item-grabbing");
            let id = element.id;
            let index = parseInt(id.replace("banner-",""));
            element.style.left = `${index*widthItem}px`;
          }
        }
        posInit = null;
        currentMove = null;
        area.onmousemove = null;
        changed = -1;
        currentIndex = -1;
      }

      function onMove(e){
        if(currentMove !== null){
          let idc = currentMove.id;
          let indexc = parseInt(idc.replace("banner-",""));
          let pos = {
            X: e.clientX-bcra.x,
            Y: e.clientY-bcra.y
          };
          let bcrc = currentMove.getBoundingClientRect();
          if(bcrb.x + 75 > bcrc.left){
            let dif = ((bcrb.x + 75) - bcrc.left);
            if(dif > 0) dif = dif/7.5;
            if(interval_id !== null){
              clearInterval(interval_id);
            }
            interval_id = setInterval(() =>{
              let ant = body.scrollLeft;
              body.scrollTo(body.scrollLeft-dif,0);
              if(ant > body.scrollLeft){
                posXpx -= ant-body.scrollLeft;
              }
              onMove(e);
            },10);
          }
           else if((bcrb.x + bcrb.width) - 75 < bcrc.x + bcrc.width){
            let dif = (bcrc.x + bcrc.width) - ((bcrb.x + bcrb.width) - 75);
            if(dif > 0) dif = dif/7.5;
            if(interval_id !== null){
              clearInterval(interval_id);
            }
            interval_id = setInterval(() =>{
              let ant = body.scrollLeft;
              body.scrollTo(body.scrollLeft+dif,0);
              if(ant < body.scrollLeft){
                posXpx += body.scrollLeft-ant;
              }
              onMove(e);
            },10);
          }
           else {
            if(interval_id !== null){
              clearInterval(interval_id);
              interval_id = null;
            }
          }
          currentMove.style.left = pos.X - posInit.X + posXpx + 'px';
          currentMove.style.transition = "0s";
          currentMove.style.zIndex = "2";

          let ppxc = pos.X - posInit.X + posXpx;
          let isChanged = false;
          let minChange = l.length;
          let maxChange = -1;
          l.forEach(element => {
            if(element.id !== currentMove.id){
              let ide = element.id;
              let indexe = parseInt(ide.replace("banner-",""));
              let ppxe = indexe*widthItem;
              let ppxec = parseInt(element.style.left.replace("px",""));
              if(ppxec !== ppxe){
                if(ppxec>ppxe) ppxe = (indexe+1)*widthItem;
                if(ppxec<ppxe) ppxe = (indexe-1)*widthItem;
              }
              if(indexe < indexc && ppxc < ppxe){
                element.style.left = `${(indexe+1)*widthItem}px`;
                isChanged = true;
                if(minChange>indexe)minChange=indexe;
              }else if(indexe > indexc && ppxc > ppxe){
                element.style.left = `${(indexe-1)*widthItem}px`;
                isChanged = true;
                if(maxChange<indexe)maxChange=indexe;
              }else{
                element.style.left = `${(indexe)*widthItem}px`;
              }
            }
          })
          if(isChanged){
            if(maxChange === -1){
              changed = minChange;
            }
            if(minChange === l.length){
              changed = maxChange;
            }
          } else {
            changed = -1;
          }
        } else {
          if(interval_id !== null){
            clearInterval(interval_id);
            interval_id = null;
          }
        }
      }

      if(editIndex === -1){
        area.onmouseleave = () => renderPos(currentMove);
        area.onmouseup = () => renderPos(currentMove);
        l.forEach(element=>{
          element.onmousedown = (e)=>{
            if(e.button === 0){
              posInit = {
                X: e.clientX-bcra.x,
                Y: e.clientY-bcra.y
              };
              currentMove = element;
              element.classList.add("item-grabbing");
              posXpx = parseInt(currentMove.style.left.replace("px",""));
              let idc = currentMove.id;
              let indexc = parseInt(idc.replace("banner-",""));
              currentIndex = indexc;
              area.onmousemove = (e) => onMove(e);
            }
          }
  
          element.onmouseup = () => renderPos(element);
        })
      } else {
        area.onmouseleave = null;
        area.onmouseup = null;
        l.forEach(element=>{
          element.onmousedown = null;
          element.onmouseup = null;
        })
      }
    }
  },[ref, refBody, update, editIndex]);

  return (
    <Modal show={true} 
      onHide={()=>{
        if(onClose)onClose();
      }}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      className="modal-fullscreen"
      centered>
      <Modal.Header closeButton>
        <Modal.Title>Configuração de Banners</Modal.Title>
      </Modal.Header>
      <Modal.Body ref={refBody}>
        <div className="modal-area-config" ref={ref} style={{width:(widthItem*(list.length+1))+'px'}}>
          {list.map((img, key)=>{
            return (
              <div className={"modal-item-config"+(editIndex===key?" modal-item-config-edit":"")} id={`banner-${key}`} key={key} style={{left:`${key*widthItem}px`, top:`10px`}}>
                {editIndex===-1?
                <>
                  <div className="modal-item-config-delete-btn" onClick={async() => {
                    let res = await BannerRequestService.delete(key);
                    if(update)update(res.data);
                  }}><FontAwesomeIcon icon={faTimes}/></div>
                  <div className="modal-item-config-edit-btn" onClick={()=>{
                    setEditIndex(key);
                  }}><FontAwesomeIcon icon={faPen}/></div>
                </>:<></>}
                <img className='d-block' alt={img.name} src={process.env.REACT_APP_URL_API+"/"+img.name}/>
                {editIndex===key?<>
                <form onSubmit={async (e)=>{
                  e.preventDefault();
                  let link = e.target.elements.link.value;
                  let description = e.target.elements.description.value;
                  let res = await BannerRequestService.edit_info(key,{link,description});
                  if(update)update(res.data);
                  setEditIndex(-1);
                }}>
                  <input type="text" placeholder="Link" disabled={editIndex!==key} name="link" defaultValue={img.link}/>
                  <textarea placeholder="Descrição" disabled={editIndex!==key} name="description" defaultValue={img.description}/>
                  <button type="submit">Salvar</button>
                  <button style={{backgroundColor:"#d9121b"}} onClick={()=>setEditIndex(-1)} type="button">Cancelar</button>
                </form>
                </>:<></>}
              </div>
            )
          })}
          <div className="modal-item-config item-config-more-btn" style={{left:`${list.length*widthItem}px`, top:`10px`}} onClick={(e)=>{
            if(!loadMoreImage){
              let inputs = e.currentTarget.getElementsByTagName("input");
              for (let i = 0; i < inputs.length; i++) {
                const input = inputs[i];
                input.click();
              }
            }
          }}>
            <input type="file" accept="image/*" multiple
              onChange={async (e) => {
                setLoadMoreImage(true);
                const files = Array.from(e.target.files)
                let res = [];
                for (let i = 0; i < files.length; i++) {
                  let file = files[i];
                  let f = new FormData();
                  f.append("file",file);
                  res = await BannerRequestService.save(f)
                }
                if(update)update(res.data);
                setLoadMoreImage(false);
              }}
            />
            {loadMoreImage?<Spinner animation="border" />:<AddCircle/>}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default function(){
  const profile = useProfile()
  const { showModal, setShowModal} = useState(false);
  const [ showModalSettings, setShowModalSettings] = useState(false);
  const [ list, setList ] = useState([]);
  const [ loaded, setLoaded ] = useState(false);
  useEffect(()=>{
    BannerRequestService.get_list().then((response)=>{
      setList(response.data)
      setLoaded(true);
    })
  },[])

  const renderCard = (!loaded || list.length>0 || profile.havePermission("banner-edit"))

  return (
    <>
    <Modal show={showModal && list.length > 0} 
      onHide={()=>{
        setShowModal(false);
      }}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      className="modal-content-banner"
      centered>
      <Modal.Header closeButton>
      </Modal.Header>
      <Modal.Body>
        <Carousel className="carousel-banner">
          {list.map((img, index)=>{
            return (
              <Carousel.Item key={index}>
                <img className='d-block w-100' alt={img.name} src={process.env.REACT_APP_URL_API+"/"+img.name}/>
                <Carousel.Caption>
                  {img.description?<p>{img.description}</p>:<></>}
                  {img.link?<a rel="noopener noreferrer" href={img.link} target="_blank">SAIBA MAIS</a>:<></>}
                </Carousel.Caption>
              </Carousel.Item>
            );
          })}
        </Carousel>
      </Modal.Body>
    </Modal>
    {showModalSettings?(<SettingsCardBanner onClose={()=>setShowModalSettings(false)} list={list} update={(list) => setList(list)}/>):<></>}
    {renderCard?(
      <Row className="justify-content-center">
        <Col className="p-1 pb-2" sm="auto">
          <Card.Body className="card-dashboard shadow bg-white rounded text-center h-100 w-100 card-dashboard-banner">
            <Can do="banner-edit" on="App">
              <div className="btn-adm" onClick={() => setShowModalSettings(true)}><Settings/></div>
            </Can>
            {!loaded?(
              <div className="p-3">
                <Spinner animation="border" />
              </div>
            ):(
              <>
                {list.length > 0 ?(
                  <Carousel className="carousel-banner">
                    {list.map((img, index)=>{
                      return (
                        <Carousel.Item key={index}>
                          <img className='d-block' alt={img.name} src={process.env.REACT_APP_URL_API+"/"+img.name}/>
                          <Carousel.Caption>
                            {img.description?<p>{img.description}</p>:<></>}
                            {img.link?<a href={img.link} rel="noopener noreferrer" target="_blank">SAIBA MAIS</a>:<></>}
                          </Carousel.Caption>
                        </Carousel.Item>
                      );
                    })}
                  </Carousel>
                ):(
                  <h5 className="p-3">Sem Banner</h5>
                )}
              </>
            )}
          </Card.Body>
        </Col>
      </Row>
    ):<></>}
    </>
  );
}